/* eslint-disable */
import { useState, useEffect, useRef } from "react";
import { UserPreference } from '../../userPreference/UserPreference';
import { Grid, GridColumn, getSelectedState } from "@progress/kendo-react-grid";
import { COLUMNSTYPE, ENTITYNAME, LOCALSTORAGE_KEY, LOGEVENT, MODULE, OFFER_STATUS, TOAST_TYPES } from '../../../framework/constant/constant';
import { EnumCell, SIDEnumCell } from '../../../framework/forms/helpercomponents/CustomGridCells/EnumCell';
import { getter } from '@progress/kendo-data-query';
import { ImageCell } from "../../../framework/forms/helpercomponents/CustomGridCells/ImageCell";
import { Loader } from "../../../framework/forms/helpercomponents/Loader";
import RoundButton from "../../../framework/forms/helpercomponents/buttons/RoundButton";
import RefreshButton from "../../../framework/forms/helpercomponents/buttons/RefreshButton";
import BackRoundButton from "../../../framework/forms/helpercomponents/buttons/BackRoundButton";
import { MultiLangArrayCell } from "../../../framework/forms/helpercomponents/CustomGridCells/MultiLangArrayCell";
import { LookupCell } from "../../../framework/forms/helpercomponents/CustomGridCells/LookupCell";
import { MyToggleButton } from "../../../framework/forms/helpercomponents/CustomGridCells/MyToggleButton";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "../../../locale/useTranslation";
import * as API from "../../../framework/API/api";
import { utility } from "../../../framework/utility/utilityProvider";
import { CheckboxCell } from "../../../framework/forms/helpercomponents/CustomGridCells/CheckBoxCell";
import { HrefCell, HyperLinkCell } from "../../../framework/forms/helpercomponents/CustomGridCells/HrefCell";
import { arrayEnumCell, daysCell, PlatformCell } from "../../../framework/forms/helpercomponents/CustomGridCells/PlatformCell";
import MyStatusCell from "../../../components/MyStatusCell";
import { DateCell, DateOnlyCell, LocalDateTimeColumn } from "../../../framework/forms/helpercomponents/CustomGridCells/DateCell";
import { colorCell } from "../../../framework/forms/helpercomponents/CustomGridCells/ColorCell";
import { TextWithIconCell } from "../../../framework/forms/helpercomponents/CustomGridCells/TextWithIconCell";
import { ContentArrayImageCell } from "../../../framework/forms/helpercomponents/CustomGridCells/ContentArrayImageCell";
import castTypeCell from "../../../framework/forms/helpercomponents/CustomGridCells/CastTypeCell";
import { IconCell } from "../../../framework/forms/helpercomponents/CustomGridCells/IconCell";
import { ArrayCell } from "../../../framework/forms/helpercomponents/CustomGridCells/ArrayCell";
import { TimeCell } from "../../../framework/forms/helpercomponents/CustomGridCells/TimeCell";
import PreferenceRoundButton from "../../../framework/forms/helpercomponents/buttons/PreferenceRoundButton";
import CollectionSelection from "../../../framework/forms/CollectionSelection";
import { MenuCommandCell } from "../../../framework/forms/helpercomponents/CustomGridCells/MenuCommandCell ";
import { collectionMenuModelAssetOfferLink } from "../../../framework/forms/helpercomponents/contextMenu/menus/collectionMenuModel";
import { ConfirmDeleteAlert } from "../../../ConfirmAlert";
import CreateTransmissionOfferForm from "./createTransmissionOfferForm";
import ToastNotification from "../../../components/ToastNotification";

const SELECTED_FIELD = "selected";
const DATA_ITEM_KEY = "_id";
const idGetter = getter(DATA_ITEM_KEY);

const VodOfferBrowser = (props) => {

    const { selectedNode = {}, isRefreshOffers = false, setIsRefreshOffers } = props;

    let page_take = props.page_take ?? 50;
    let showBack = props.showBack ?? true;
    let showTitle = props.showTitle ?? true;
    let filterable = props.filterable ?? false;
    let sortable = props.sortable ?? true;
    let isPageable = props.isPageable ?? true;
    let sort = props.sort ?? { _id: 1 };
    let customColumns = props.customColumns ?? [];
    let entityName = props.entityname;
    let enableMutliSelect = props.enableMutliSelect ?? false;
    let showCommandCell = props.showCommandCell ?? true;

    const navigate = useNavigate();

    const [gridData, setGridData] = useState([]);
    const [total, setTotal] = useState(1);
    const [isLoading, setIsLoading] = useState(true);
    const [isNoRecords, setIsNoRecords] = useState(false);
    const [showPreferences, setShowPreferences] = useState(false);
    const [dataColumns, setDataColumns] = useState([]);
    const [selectedState, setSelectedState] = useState({});
    const initialSort = { field: Object.keys(sort)[0], dir: sort[Object.keys(sort)[0]] == 1 ? "asc" : "desc" }
    const [gridSort, setGridSort] = useState([initialSort]);

    //----------FOR CREATE TRANSMISSION
    const [showAttachOffers, setShowAttachOffers] = useState({ show: false });
    const [showCreateAndAttchOffersForm, setShowCreateAndAttchOffersForm] = useState({ show: false, item: null });

    const selectedItemsRef = useRef([]);
    const setSelectedItem = (items) => {
        selectedItemsRef.current = items;
    }

    const gridRef = useRef(null);
    const [page, setPage] = useState({
        skip: 0,
        take: page_take,
    });

    const loc = useLocation();
    const lang = useTranslation();

    let href = loc.state ? loc.state.href : false;
    if (href) {
        wherestatement = loc.state.wherestatement;
    }

    useEffect(() => {
        loadData({ per_page: page_take, current_page: 1 });
    }, [props.entityname, props.gridData, props.title, selectedNode, isRefreshOffers]);


    const loadData = async (pagination) => {

        if (props.gridColumns) {
            setDataColumns(props.gridColumns);
            setGridData(props.gridData);
        } else {
            try {
                setIsLoading(true);
                let currentUserId = utility.getValue(LOCALSTORAGE_KEY.user_id);
                let columns = await API.getFormData(ENTITYNAME.NodeOfferLink, currentUserId);
                let payload = {
                    page: pagination.current_page,
                    perPage: pagination.per_page,
                    nodeId: selectedNode?._id
                }
                let json = await API.getNodeOfferLink(payload);
                console.log(json);

                setGridData(json?.data ?? []);
                setTotal(json?.pagination?.total);
                props.handleCount && props.handleCount("Offers", json?.pagination?.total);
                customColumns.length > 0 ? setDataColumns(customColumns) : setDataColumns(columns);

            } catch (error) {
                console.log("error", error);
                setIsNoRecords(true);
            }
        }

        setIsLoading(false);
        setIsRefreshOffers && setIsRefreshOffers(false);
    };

    const onCloseUserPrefence = () => {
        let sortEvent = gridSort[0] ?? initialSort;
        loadData({ per_page: page_take, current_page: 1, orderby: sortEvent.field, direction: sortEvent.dir });
        setShowPreferences(!showPreferences);
    }

    const MyCheckBoxCell = (props) => {
        const value = props?.dataItem?.[props.field];
        return (
            <td style={{ marginLeft: "10px" }}>
                {value === 1 ? 'Yes' : 'No'}
            </td>
        );
    };

    const MyCustomToggleButton = (props) => (
        <MyToggleButton
            {...props}
            entityName={entityName}
            size={"small"}
            onGridDataUpdate={updateGridDataByIndex}
        />
    );

    const updateGridDataByIndex = (index, field, value) => {
        const updated = [...gridData];
        if (updated[index]) {
            updated[index] = { ...updated[index], [field]: value };
            setGridData(updated);
        }
    };

    const handleAttachOffers = async (offerData = []) => {

        if (offerData?.length === 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "No offers found!" });
            return;
        }

        let finalData = {
            node: {
                _id: selectedNode._id,
                CSID: selectedNode.CSID,
                Name: selectedNode.Name
            },
            offers: offerData.map(x => {
                return {
                    _id: x._id,
                    CSID: x.CSID,
                    Title: x.Title,
                }
            })
        };
        let res = await API.nodeAttachOffersLink(finalData);

        if (res.success) {
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: res.message });
            refreshData();
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }

    const MyDatalookupCell = (props) => (
        <LookupCell {...props} dataColumns={dataColumns} />
    );

    const MyMultiLangArrayCell = (props) => (
        <MultiLangArrayCell selectedLang={selectedLanguageRef.current} {...props} />
    )

    const pageChange = async (e) => {
        let current_page = e.page.skip / e.page.take + 1;
        let sortEvent = gridSort[0] ?? initialSort;
        const url = new URL(window.location);
        url.searchParams.set('page', current_page);
        url.searchParams.set('index', 0);
        window.history.pushState({}, '', url);
        await loadData({ per_page: e.page.take, current_page: current_page, orderby: sortEvent.field, direction: sortEvent.dir });
        setPage(e.page);
        cancelSelectedItem();
    };

    const refreshCollection = () => {
        setIsLoading(true);
        let current_page = page.skip / page.take + 1;
        loadData({ per_page: page.take, current_page: current_page, orderby: "SID", direction: "asc" });
        setGridSort([initialSort]);
    }

    const onSortChange = (e) => {
        setGridSort(e.sort)
        let sortEvent = e.sort[0] ?? sort;
        let current_page = page.skip / page.take + 1;
        loadData({ per_page: page.take, current_page: current_page, orderby: sortEvent.field, direction: sortEvent.dir });
    }

    const onSelectionChange = (event) => {
        const newSelectedState = getSelectedState({
            event,
            selectedState: selectedState,
            dataItemKey: DATA_ITEM_KEY,
        });
        setSelectedState(newSelectedState);

        let selectedIds = Object.keys(newSelectedState);
        let tempSelected = [];

        selectedIds.map((value) => {
            if (newSelectedState[value]) {
                let filter = gridData.find((obj) => obj._id == value);
                tempSelected.push(filter);
            }
        });

        setSelectedItem(tempSelected);
    };

    const onHeaderSelectionChange = (event) => {
        const checkboxElement = event.syntheticEvent.target;
        const checked = checkboxElement.checked;
        const newSelectedState = {};
        event.dataItems.forEach((item) => {
            newSelectedState[idGetter(item)] = checked;
        });
        setSelectedState(newSelectedState);

        var selectedIds = Object.keys(newSelectedState);
        var tempSelected = [];

        if (checked) {
            selectedIds.map((value) => {
                if (newSelectedState[value]) {
                    var filtered = gridData.find((obj) => obj._id == value);
                    tempSelected.push(filtered);
                }
            });
        }
        setSelectedItem(tempSelected);
    };

    const cancelSelectedItem = () => {
        setSelectedItem([]);
        setSelectedState({});
    }

    let timeOut;
    const handleColumnResize = (event) => {
        let lockedCol = event.columns.filter((item) => item?.locked).length ?? 1;
        try {
            if (event.index == 0) return;
            if (dataColumns == undefined || dataColumns.length == 0 || dataColumns.length < event.index) return;
            let column = dataColumns[event.index - lockedCol];
            let payload = {
                entityName: column?.entityName,
                name: column?.name,
                width: event.newWidth
            };
            clearTimeout(timeOut);
            timeOut = setTimeout(() => {
                API.updateUserPreferenceColumnWidth(payload);
            }, 700);
        } catch (error) {
            console.error("Error handling column resize:", error);
        }
    };

    const StatusCell = (props) => {
        const { dataItem = {}, field } = props;

        let value = utility.getNestedValue(dataItem, field);
        let title = utility.getKeyByValue(OFFER_STATUS, value);
        let tileBackColor = "";

        switch (value) {
            case OFFER_STATUS.Active:
                tileBackColor = "#63AA43";
                break;
            case OFFER_STATUS.Upcoming:
                tileBackColor = "#F8A506";
                break;
            default:
                tileBackColor = "#E72929";
                break;
        }

        return (<td style={{ padding: "3px" }}>
            <MyStatusCell {...props} style={{ width: "100px", }} title={title} tileBackColor={tileBackColor} />
        </td>);
    };

    const handleDeleteSelectedItem = async (data = {}) => {
        try {
            let res = await API.deleteData(ENTITYNAME.NodeOfferLink, data.nodeOfferLink_id, "_id");
            if (res.success) {
                let logData = { event: LOGEVENT.NODE_OFFER_DETACH, message: "Node Offer Detached Successfully", module: MODULE.NODE_BROWSER, data: {}, _id: data.nodeOfferLink_id };
                await API.SaveLogs(logData);
            }
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: res.message });
            refreshData();
        } catch (error) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: error.message });
        }
    }

    const handleDelete = async (dataItem) => {
        ConfirmDeleteAlert(() => handleDeleteSelectedItem(dataItem), () => { });
    }

    const handleEdit = async (dataItem) => {
        console.log(dataItem);

        const res = await API.getData(ENTITYNAME.OFFER, { query: [["_id", "=", dataItem._id]] });
        console.log(res);

        const offerData = res?.data?.[0] ?? {};
        setShowCreateAndAttchOffersForm({ show: true, item: offerData });
    };

    const MyCommandCell = (props) => (
        <MenuCommandCell
            {...props}
            myMenuModel={collectionMenuModelAssetOfferLink}
            onDelete={handleDelete}
            onEdit={handleEdit}
            showEdit={true}
        />
    );

    const refreshData = () => {
        loadData({ per_page: page_take, current_page: 1 });
        props.refreshTransmission && props.refreshTransmission();
    }

    return (
        <>
            <div style={props.mainStyle ?? {}}>
                {showTitle && <div className='d-flex'>
                    <div className='mr-auto d-flex'>
                        <h3 className='mr-1' style={{ margin: 0, fontSize: '18px', fontWeight: 'bold' }}>{lang.offers_label}</h3>
                        <p style={{ fontSize: '13px', color: '#666' }}> ({total} {total === 1 ? 'item' : 'items'} found) </p>
                    </div>
                    {selectedNode?.Name && <p style={{ fontSize: '13px', color: '#666' }}>{`${selectedNode.Name} (${selectedNode?.CSID})`}</p>}
                </div>}
                <div style={{ width: "100%" }}>
                    <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", marginBottom: '15px', gap: '5px' }}>
                        <div>
                            {showBack && (<BackRoundButton onClick={() => navigate(-1)} />)}
                        </div>
                        <div>
                            <RoundButton icon={"plus"} onClick={() => setShowCreateAndAttchOffersForm({ show: true, item: null })} title={lang.create_and_attach_offers_button_tooltip} />
                        </div>
                        <div>
                            <RoundButton icon={"paperclip"} onClick={() => setShowAttachOffers({ show: true })} title={lang.attach_offers_button_tooltip} />
                        </div>
                        <div>
                            <RefreshButton onClick={refreshCollection} />
                        </div>
                        <div>
                            <PreferenceRoundButton icon={"gear"} title={lang.preference_button_tooltip} onClick={() => setShowPreferences(!showPreferences)} />
                        </div>
                    </div>
                </div>
                {isLoading && <Loader height={props?.gridstyle?.height ?? "auto"} />}
                {isNoRecords && <div style={{ margin: "0px 500px" }}><h4><strong>{lang.no_records_found}</strong></h4></div>}
                {!isLoading && !isNoRecords &&
                    <Grid
                        style={props.gridstyle ?? {
                            height: 'calc(100vh - 190px)'
                        }}
                        ref={gridRef}
                        sort={gridSort}
                        sortable={sortable}
                        onSortChange={onSortChange}
                        filterable={filterable}
                        pageable={isPageable}
                        skip={page.skip}
                        take={page.take}
                        onPageChange={pageChange}
                        total={total}
                        resizable={true}
                        onColumnResize={handleColumnResize}
                        data={
                            gridData.map((item) => ({
                                ...item,
                                [SELECTED_FIELD]: selectedState[idGetter(item)],
                            }))}
                        selectedField={SELECTED_FIELD}
                        selectable={{
                            enabled: enableMutliSelect,
                            drag: false,
                            cell: false,
                            mode: "multiple",
                        }}
                        dataItemKey={DATA_ITEM_KEY}
                        onSelectionChange={onSelectionChange}
                        onHeaderSelectionChange={onHeaderSelectionChange}
                    >
                        {showCommandCell && (
                            <GridColumn cell={MyCommandCell} width={"60px"} locked={true} resizable={false} />
                        )}
                        {dataColumns.map((column, index) => {
                            if (column.type === COLUMNSTYPE.date) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={DateOnlyCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        sortable={true}
                                    />
                                );
                            } else if (column.type === COLUMNSTYPE.datetime) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={DateCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        sortable={true}
                                    />
                                );
                            } else if (column.name.includes("Duration") || column.type == COLUMNSTYPE.time) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={TimeCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        sortable={true}
                                    />
                                );
                            } else if (column.name === "SID") {
                                return;
                            } else if (column.type === COLUMNSTYPE.image) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={(p) => ImageCell({ ...p, title: column.label })}
                                        title={column.label}
                                        width={column.width ?? 100}
                                        sortable={false}
                                    />
                                );
                            } else if (column.type === COLUMNSTYPE.select) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={MyDatalookupCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.toggle) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={MyCustomToggleButton}
                                        title={column.label}
                                        width={85}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.checkbox) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={CheckboxCell}
                                        title={column.label}
                                        width={column.width ?? 80}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.array) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={ArrayCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        format={column.format ?? "Description"}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.href) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={HrefCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        format={column.format}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.hyperlink) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={HyperLinkCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        format={column.format}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.enum) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={EnumCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        format={column.format ?? "Description"}
                                        sortable={true}
                                    />
                                );
                            } else if (column.type === COLUMNSTYPE.platform) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={PlatformCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.status) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={StatusCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.localdatetime) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={LocalDateTimeColumn}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        sortable={true}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.icon) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={IconCell}
                                        title={column.label}
                                        width={column.width ?? 80}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.arrayenum) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={arrayEnumCell}
                                        title={column.label}
                                        width={column.width ?? 80}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.color) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={colorCell}
                                        title={column.label}
                                        width={column.width ?? 80}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.day) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={daysCell}
                                        title={column.label}
                                        width={column.width ?? 80}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.multiLangCell) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={MyMultiLangArrayCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.textWithIcon) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={TextWithIconCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.imageArrayCell) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={ContentArrayImageCell}
                                        title={column.label}
                                        width={column.width ?? 350}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.castType) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={castTypeCell}
                                        title={column.label}
                                        width={column.width ?? 80}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.SIDEnum) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={(props) => SIDEnumCell({ ...props, fk_entityName: column.fk_entityName, fk_field: column.fk_field })}
                                        title={column.label}
                                        width={column.width ?? 80}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.boolean) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={MyCheckBoxCell}
                                        title={column.label}
                                        width={column.width ?? 80}
                                    />
                                );
                            }
                            else {
                                return (
                                    column.type !== COLUMNSTYPE.hidden && (
                                        <GridColumn
                                            key={index}
                                            field={column.name}
                                            title={column.label}
                                            width={column.width ?? 200}
                                            sortable={true}
                                        />
                                    )
                                );
                            }
                        })}
                    </Grid>}
            </div>

            {showPreferences && <UserPreference entityName={ENTITYNAME.NodeOfferLink} preferenceColumnENntityName={ENTITYNAME.NodeOfferLink} handleClose={onCloseUserPrefence} />}
            {showAttachOffers.show && <CollectionSelection title={lang.select_offers_label} showCreate={true} path="/home/offer" wherestatement={['EndDateTime', '>', utility.getCurrentDate()]} setDataList={handleAttachOffers} closeForm={() => setShowAttachOffers({ show: false })} addButtonTitle={lang.select_button_text} entityname={ENTITYNAME.OFFER} width={"50vw"} />}
            {showCreateAndAttchOffersForm.show && <CreateTransmissionOfferForm item={showCreateAndAttchOffersForm.item} node={selectedNode} cancelEdit={() => { setShowCreateAndAttchOffersForm({ show: false, item: null }) }} refreshData={refreshData} />}

        </>
    );
};

export default VodOfferBrowser;